import {gql} from 'apollo-angular';
import {ImageFragment} from "./Image";

export const StoryFragment = gql`
  fragment storyFields on Story {
    id
    title
    portrait
    bicID
    vrDirectLink
    icon {
      iconValue
      color
    }
    gradient
    color
    user {
      avatar {
        ...imageFields
      }
      position
    }
    image {
      ...imageFields
    }
    cards {
      image {
        ...imageFields
      }
      layout
      highlightPosition
      #          imagePosition
      backgroundVideo {
        title
        author
        authorUrl
        thumbnailUrl
        thumbnailHeight
        thumbnailWidth
        src
      }
      backgroundImage {
        ...imageFields
      }
      textHeading
      text
      time
      title
      embedVideo {
        title
        author
        authorUrl
        thumbnailUrl
        thumbnailHeight
        thumbnailWidth
        src
      }
      lottieAnimation
      theme
    }
    nextStories {
      title
      description
      stories {
        avatar {
          ...imageFields
        }
        title
        linkTitle
        storyId
      }
    }
    schoolProfile {
      uuid
    }
  }
  ${ImageFragment}
`;
